import { defineMessages } from 'react-intl'

export const homeServicesEventsMessages = defineMessages({
  formHeading: {
    id: 'homeServicesEventsMessages.formHeading',
    description: 'Heading for Send Events form on home services page',
    defaultMessage: 'Service Events',
  },
  zonePlaceholder: {
    id: 'homeServicesEventsMessages.zonePlaceholder',
    description:
      'Zone field placeholder for Send Events form on home services page',
    defaultMessage: 'Zone',
  },
  servicePlaceholder: {
    id: 'homeServicesEventsMessages.servicePlaceholder',
    description:
      'Service field placeholder for Send Events form on home services page',
    defaultMessage: 'Service',
  },
  eventPlaceholder: {
    id: 'homeServicesEventsMessages.eventPlaceholder',
    description:
      'Event field placeholder for Send Events form on home services page',
    defaultMessage: 'Event',
  },
  typePlaceholder: {
    id: 'homeServicesEventsMessages.typePlaceholder',
    description:
      'Type field placeholder for Send Events form on home services page',
    defaultMessage: 'Type',
  },
  argumentsHeader: {
    id: 'homeServicesEventsMessages.argumentsHeader',
    description:
      'Arguments header for arguments block in Send Events form on home services page',
    defaultMessage: 'Arguments',
  },
  argumentsNamePlaceholder: {
    id: 'homeServicesEventsMessages.argumentsNamePlaceholder',
    description:
      'Placeholder for arguments "name" input in Send Events form on home services page',
    defaultMessage: 'Name',
  },
  argumentsValuePlaceholder: {
    id: 'homeServicesEventsMessages.argumentsValuePlaceholder',
    description:
      'Placeholder for arguments "Value" input in Send Events form on home services page',
    defaultMessage: 'Value',
  },
  addArgumentButton: {
    id: 'homeServicesEventsMessages.addArgumentButton',
    description:
      'Label for "Add argument" button in Send Events form on home services page',
    defaultMessage: 'Add Argument',
  },
  resetButton: {
    id: 'homeServicesEventsMessages.resetButton',
    description:
      'Label for "reset" button in Send Events form on home services page',
    defaultMessage: 'Reset',
  },
  sendEventButton: {
    id: 'homeServicesEventsMessages.sendEventButton',
    description:
      'Label for "Send Event" button in Send Events form on home services page',
    defaultMessage: 'Send Event',
  },
  allZonesDropdownOption: {
    id: 'homeServicesMessages.allZonesDropdownOption',
    description:
      'Label for dropdown "All zones" option in Send Events form on home services page',
    defaultMessage: 'All zones',
  },
  allServicesDropdownOption: {
    id: 'homeServicesMessages.allServicesDropdownOption',
    description:
      'Label for dropdown "All services" option in Send Events form on home services page',
    defaultMessage: 'All services',
  },
  allTypesDropdownOption: {
    id: 'homeServicesMessages.allTypesDropdownOption',
    description:
      'Label for dropdown "All types" option in Send Events form on home services page',
    defaultMessage: 'All types',
  },
})
